import React, { Component } from "react";
import axios from "axios";
import api from "../api";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import Button from "@material-ui/core/Button";
import NumberFormat from "react-number-format";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  Input,
  InputLabel,
  Link,
  MenuItem,
  Select,
  TextareaAutosize
} from "@material-ui/core";
import MediaFile from "../MediaFile";
import CancelIcon from "@material-ui/icons/Cancel";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = theme => ({
  root: {
    flexGrow: 1,
    width: "100%"
  },
  appBar: {
    position: "relative"
  },
  title: {
    marginLeft: "2rem",
    flex: 1,
    color: "white"
  },
  paper: {
    padding: "2rem",
    textAlign: "center"
  },
  checkedIcon: {
    width: 16,
    height: 16
  },
  option: {
    fontWeight: 600,
    fontSize: "0.75rem"
  },
  typography: {
    fontSize: "0.75rem"
  },
  select: {
    marginTop: "0",
    marginRight: "12px",
    padding: "0"
  },
  menu: {
    fontSize: "0.75rem"
  }
});

class Fine extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    work_order_fine: { work_order: { user_id: "" }, amount: 0, voluntary_payment_amount: 0 },
      snackbar: { open: false },
      providers: [],
      provinces: [],
      cities: [],
      files: [],
      fine_tasks: [],
      loading: true
    };
  }

  async componentDidMount() {
    var work_order_id = this.props.id;
    await this.getProvinces();
    await this.getProviders();
    await this.getWorkOrderFineTasks();
    await this.getWorkOrderFine(work_order_id);
    this.setState({ loading: false });
  }

  async getWorkOrderFineTasks() {
    const token = localStorage.getItem("userToken");
    return await axios
      .get(api.work_order_fine().getFineTasks(), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        this.setState({ fine_tasks: res.data });
      })
      .catch(err => {
        console.log(err);
      });
  }

  async getProviders() {
    const token = localStorage.getItem("userToken");
    return await axios
      .get(api.providers().index("", "", "", "", "", 10, ""), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        this.setState({ providers: res.data.data });
      })
      .catch(err => {
        console.log(err);
      });
  }

  async getProvinces() {
    const token = localStorage.getItem("userToken");
    return await axios
      .get(api.provinces().get(), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        this.setState({ provinces: res.data });
      })
      .catch(err => {
        console.log(err);
      });
  }

  async getCities(province_id) {
    const token = localStorage.getItem("userToken");
    return await axios
      .get(api.provinces().cities(province_id), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        this.setState({ cities: res.data });
      })
      .catch(err => {
        console.log(err);
      });
  }

  async getWorkOrderFine(id) {
    const token = localStorage.getItem("userToken");
    return await axios
      .get(api.work_order_fine().get(id), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        var work_order_fine = res.data;
        work_order_fine.paid = work_order_fine.paid > 0 ? true : false;
        this.setState({ work_order_fine: work_order_fine, loading: false });
        if (work_order_fine.province_id) {
          this.getCities(work_order_fine.province_id);
        }
      })
      .catch(err => {
        console.log(err);
      });
  }

  handleChange = e => {
    var work_order_fine = this.state.work_order_fine;
    work_order_fine[e.target.name] = e.target.value;
    if (e.target.name === "paid") {
      work_order_fine[e.target.name] = e.target.checked;
    }
    this.setState({ work_order_fine: work_order_fine });

    if (e.target.name === "province_id") {
      this.getCities(e.target.value);
    }
  };

  handleUploadFile = (file, meta_data) => {
    var files_state = this.state.files;
    var file = { file: file, meta_data: meta_data };
    files_state.push(file);
    this.setState({ files: files_state });
  };

  handleSendEmail = e => {
    var self = this;
    e.preventDefault();
    var formData = new FormData();
    formData.set("work_order_fine_id", this.state.work_order_fine.id);
    const token = localStorage.getItem("userToken");
    axios
      .post(
        api.work_order_fine().sendEmail(this.state.work_order_fine.id),
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`
          }
        }
      )
      .then(response => {
        var snackbar = {
          open: true,
          success_message: "Email enviado con éxito",
          severity: "success"
        };
        this.setState({ snackbar: snackbar });
      })
      .catch(function(error) {
        var error_message = "";
        var errors = error.response.data;
        if (errors.errors) {
          if (errors.errors.status_code !== 404) {
            console.log("!!,", errors);
            var keys = Object.keys(errors.errors);
            for (var i = 0; i < keys.length; i++) {
              var key = keys[i];
              var key_errors = errors.errors[key];
              key_errors.map((val, idx) => {
                error_message = error_message.concat(val).concat(" ");
              });
            }
          } else {
            error_message = error_message.concat(error.message).concat(" ");
          }
        }
        if (errors.message == "") {
          error_message =
            "Ha ocurrido un error al enviar el email. Por favor contacte con su administrador";
        }
        var snackbar = {
          open: true,
          success_message: error_message,
          severity: "warning"
        };
        self.setState({ snackbar: snackbar });
      });
  };

  handleSubmit = () => {
    var formData = new FormData();
    var url = api.work_order_fine().post();
    formData.set("work_order_fine[work_order_id]", this.props.id);
    formData.set(
      "work_order_fine[province_id]",
      this.state.work_order_fine.province_id
        ? this.state.work_order_fine.province_id
        : ""
    );
    formData.set(
      "work_order_fine[city_id]",
      this.state.work_order_fine.city_id
        ? this.state.work_order_fine.city_id
        : ""
    );
    formData.set(
      "work_order_fine[date]",
      this.state.work_order_fine.date ? this.state.work_order_fine.date : ""
    );
    formData.set(
      "work_order_fine[type]",
      this.state.work_order_fine.type ? this.state.work_order_fine.type : ""
    );
    formData.set(
      "work_order_fine[fine_task_id]",
      this.state.work_order_fine.fine_task_id
        ? this.state.work_order_fine.fine_task_id
        : ""
    );
    formData.set(
      "work_order_fine[description]",
      this.state.work_order_fine.description
        ? this.state.work_order_fine.description
        : ""
    );
    formData.set(
      "work_order_fine[reference]",
      this.state.work_order_fine.reference
        ? this.state.work_order_fine.reference
        : ""
    );
    formData.set(
      "work_order_fine[amount]",
      this.state.work_order_fine.amount
        ? this.state.work_order_fine.amount.toString().replace("$", "")
        : 0
    );
    formData.set(
      "work_order_fine[voluntary_payment_amount]",
      this.state.work_order_fine.voluntary_payment_amount
        ? this.state.work_order_fine.voluntary_payment_amount.toString().replace("$", "")
        : 0
    );
    formData.set(
      "work_order_fine[paid]",
      this.state.work_order_fine.paid ? 1 : 0
    );
    formData.set(
      "work_order_fine[payment_method]",
      this.state.work_order_fine.payment_method
        ? this.state.work_order_fine.payment_method
        : ""
    );
    formData.set(
      "work_order_fine[payment_reference]",
      this.state.work_order_fine.payment_reference
        ? this.state.work_order_fine.payment_reference
        : ""
    );
    formData.set(
      "work_order_fine[provider_id]",
      this.state.work_order_fine.provider_id
        ? this.state.work_order_fine.provider_id
        : ""
    );
    formData.set("work_order_fine[work_order_id]", this.props.id);

    if (this.state.work_order_fine.paid === false) {
      formData.set("work_order_fine[payment_method]", "");
      formData.set("work_order_fine[payment_reference]", "");
      formData.set("work_order_fine[provider_id]", "");
    }
    if (this.state.work_order_fine.id) {
      url = api.work_order_fine().patch(this.props.id);
      formData.set("work_order_fine[id]", this.state.work_order_fine.id);
      formData.set("_method", "PATCH");
    }
    let i = 0;
    if (this.state.files) {
      this.state.files.map((val, idx) => {
        if (val.file !== "" && val.file !== undefined) {
          formData.append("media[" + i + "][file]", val.file[0]);
          i++;
        }
      });
    }

    let self = this;
    const token = localStorage.getItem("userToken");
    axios
      .post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`
        }
      })
      .then(response => {
        var snackbar = {
          open: true,
          success_message: "Infracción cargada con éxito",
          severity: "success"
        };
        self.setState({ snackbar: snackbar });
      })
      .catch(function(error) {
        //	      		var error_message = 'Ha ocurrido un error al cargar el movimiento. Por favor contacte con su administrador'
        var error_message = "";
        var errors = error.response.data;
        if (errors.errors) {
          if (errors.errors.status_code !== 404) {
            var keys = Object.keys(errors.errors);
            for (var i = 0; i < keys.length; i++) {
              var key = keys[i];
              var key_errors = errors.errors[key];
              key_errors.map((val, idx) => {
                error_message = error_message.concat(val).concat(" ");
              });
            }
          } else {
            error_message = error_message.concat(error.message).concat(" ");
          }
        }
        if (errors.message == "") {
          error_message =
            "Ha ocurrido un error al cargar la infracción. Por favor contacte con su administrador";
        }
        var snackbar = {
          open: true,
          success_message: error_message,
          severity: "warning"
        };
        self.setState({ snackbar: snackbar });
      });
  };

  handleSnackbar = () => {
    var snackbar = this.state.snackbar;
    snackbar.open = !snackbar.open;
    this.setState({ snackbar: snackbar });
  };
  handleDeleteMedia = id => {
    const token = localStorage.getItem("userToken");
    axios
      .delete(
        api.media().delete(id),
        { headers: { Authorization: `Bearer ${token}` } },
        { params: { "media[id]": id } }
      )
      .then(response => {
        var snackbar = {
          open: true,
          success_message: "Adjunto eliminado con éxito",
          severity: "success"
        };
        this.setState({ snackbar: snackbar });
        this.getWorkOrderFine(this.props.id);
      })
      .catch(function(error) {
        var snackbar = {
          open: true,
          success_message:
            "No pudo borrarse el adjunto. Por favor contacte a su administrador",
          severity: "warning"
        };
        this.setState({ snackbar: snackbar });
      });
  };

  render() {
    var work_order_fine = this.state.work_order_fine;
    const classes = this.props.classes;
    return (
      <React.Fragment>
        <Snackbar
          open={this.state.snackbar.open}
          autoHideDuration={10000}
          onClose={this.handleSnackbar}
        >
          <Alert
            onClose={this.handleSnackbar}
            severity={this.state.snackbar.severity}
          >
            {this.state.snackbar.success_message}
          </Alert>
        </Snackbar>
        {this.state.loading ? (
          ""
        ) : (
          <React.Fragment>
            <div className="row mt-2">
              <TextField
                id="province_id"
                name="province_id"
                select
                margin="normal"
                className="mr-2 mt-1"
                InputLabelProps={{
                  shrink: true
                }}
                onChange={this.handleChange}
                value={work_order_fine.province_id}
                inputProps={{
                  style: { minWidth: 70, fontSize: "0.75rem" }
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography variant="caption" style={{ width: 75 }}>
                        Provincia
                      </Typography>
                    </InputAdornment>
                  ),
                  style: { fontSize: "0.75rem" }
                }}
              >
                {this.state.provinces.map(option => (
                  <MenuItem
                    key={option.id}
                    value={option.id}
                    style={{ fontSize: "0.75rem" }}
                  >
                    {option.name}
                  </MenuItem>
                ))}
              </TextField>
              <TextField
                id="city_id"
                name="city_id"
                select
                margin="normal"
                className="mr-2 mt-1"
                InputLabelProps={{
                  shrink: true
                }}
                onChange={this.handleChange}
                value={work_order_fine.city_id}
                inputProps={{
                  style: { minWidth: 70, fontSize: "0.75rem" }
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography variant="caption" style={{ width: 75 }}>
                        Ciudad
                      </Typography>
                    </InputAdornment>
                  ),
                  style: { fontSize: "0.75rem" }
                }}
              >
                {this.state.cities.map(option => (
                  <MenuItem
                    key={option.id}
                    value={option.id}
                    style={{ fontSize: "0.75rem" }}
                  >
                    {option.name}
                  </MenuItem>
                ))}
              </TextField>

              <TextField
                id="date"
                value={work_order_fine.date}
                onChange={this.handleChange}
                type="datetime-local"
                name="date"
                margin="normal"
                className="m-0 p-0 mr-2"
                InputLabelProps={{
                  shrink: true
                }}
                inputProps={{ style: { minWidth: 70, fontSize: "0.75rem" } }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography variant="caption">
                        Fecha infracción
                      </Typography>
                    </InputAdornment>
                  )
                }}
              />
              <TextField
                id="fine_task_id"
                name="fine_task_id"
                select
                margin="normal"
                className="mr-2 mt-1"
                InputLabelProps={{
                  shrink: true
                }}
                onChange={this.handleChange}
                value={work_order_fine.fine_task_id}
                inputProps={{
                  style: { minWidth: 70, fontSize: "0.75rem" }
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography variant="caption" style={{ width: 75 }}>
                        Motivo
                      </Typography>
                    </InputAdornment>
                  ),
                  style: { fontSize: "0.75rem" }
                }}
              >
                {this.state.fine_tasks.map(option => (
                  <MenuItem
                    key={option.id}
                    value={option.id}
                    style={{ fontSize: "0.75rem" }}
                  >
                    {option.name}
                  </MenuItem>
                ))}
              </TextField>

              <TextField
                id="description"
                name="description"
                value={work_order_fine.description}
                onChange={this.handleChange}
                fullWidth
                type="text"
                margin="normal"
                className="m-0 p-0 mr-2"
                InputLabelProps={{
                  shrink: true
                }}
                inputProps={{ style: { minWidth: 150, fontSize: "0.75rem" } }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography variant="caption">Detalle</Typography>
                    </InputAdornment>
                  ),
                  style: { fontSize: "0.75rem" }
                }}
              />
              <TextField
                id="reference"
                value={work_order_fine.reference}
                onChange={this.handleChange}
                type="text"
                name="reference"
                margin="normal"
                className="m-0 p-0 mr-2"
                InputLabelProps={{
                  shrink: true
                }}
                inputProps={{ style: { fontSize: "0.75rem" } }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography variant="caption">Acta</Typography>
                    </InputAdornment>
                  )
                }}
              />
              <NumberFormat
                id="amount"
                name="amount"
                value={work_order_fine.amount ? work_order_fine.amount : 0}
                onChange={this.handleChange}
                className="mr-2"
                InputProps={{
                  style: { fontSize: "0.75rem", width: 250 },
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography variant="caption">Monto multa</Typography>
                    </InputAdornment>
                  )
                }}
                decimalSeparator="."
                prefix={"$"}
                customInput={TextField}
                InputLabelProps={{
                  shrink: true
                }}
              />
              <NumberFormat
                id="voluntary_payment_amount"
                name="voluntary_payment_amount"
                value={work_order_fine.voluntary_payment_amount ? work_order_fine.voluntary_payment_amount : 0}
                onChange={this.handleChange}
                className="mr-2"
                InputProps={{
                  style: { fontSize: "0.75rem", width: 250 },
                }}
                decimalSeparator="."
                prefix={"$"}
                customInput={TextField}
                InputLabelProps={{
                  shrink: true
                }}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    id="paid"
                    name="paid"
                    className={classes.checkbox}
                    onChange={this.handleChange}
                    value={work_order_fine.paid ? work_order_fine.paid : false}
                    checked={
                      work_order_fine.paid ? work_order_fine.paid : false
                    }
                    color="primary"
                    inputProps={{ "aria-label": "secondary checkbox" }}
                  />
                }
                label={<Typography variant="caption">Pagada?</Typography>}
                labelPlacement="start"
              />
              {work_order_fine.paid && (
                <>
                  <TextField
                    id="provider_id"
                    name="provider_id"
                    select
                    margin="normal"
                    className="mr-2 mt-1"
                    InputLabelProps={{
                      shrink: true
                    }}
                    onChange={this.handleChange}
                    value={work_order_fine.provider_id}
                    inputProps={{
                      style: { minWidth: 70, fontSize: "0.75rem" }
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Typography variant="caption" style={{ width: 75 }}>
                            Proveedor
                          </Typography>
                        </InputAdornment>
                      ),
                      style: { fontSize: "0.75rem" }
                    }}
                  >
                    {this.state.providers.map(option => (
                      <MenuItem
                        key={option.id}
                        value={option.id}
                        style={{ fontSize: "0.75rem" }}
                      >
                        {option.business_name}
                      </MenuItem>
                    ))}
                  </TextField>

                  <TextField
                    id="payment_method"
                    value={work_order_fine.payment_method}
                    onChange={this.handleChange}
                    type="text"
                    name="payment_method"
                    margin="normal"
                    className="m-0 p-0 mr-2"
                    InputLabelProps={{
                      shrink: true
                    }}
                    inputProps={{ style: { fontSize: "0.75rem" } }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Typography variant="caption">
                            Medio de pago
                          </Typography>
                        </InputAdornment>
                      )
                    }}
                  />
                  <TextField
                    id="payment_reference"
                    value={work_order_fine.payment_reference}
                    onChange={this.handleChange}
                    type="text"
                    name="payment_reference"
                    margin="normal"
                    className="m-0 p-0 mr-2"
                    InputLabelProps={{
                      shrink: true
                    }}
                    inputProps={{ style: { fontSize: "0.75rem" } }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Typography variant="caption">
                            Comprobante pago
                          </Typography>
                        </InputAdornment>
                      )
                    }}
                  />
                </>
              )}
            </div>
            {this.state.work_order_fine.id && (
              <div className="row">
                <TextareaAutosize
                  id={"email_content"}
                  value={this.state.work_order_fine.email_content}
                  onChange={this.handleChange}
                  name="body"
                  disabled
                  margin="normal"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Typography variant="caption" style={{ minWidth: 50 }}>
                          Email{" "}
                        </Typography>
                      </InputAdornment>
                    )
                  }}
                  minRows={5}
                  placeholder="Agregue descripción del ticket"
                  className="mr-2 mt-0"
                  InputLabelProps={{
                    shrink: true
                  }}
                  style={{ width: "100%", fontSize: "0.75rem" }}
                />
              </div>
            )}
            <div className="row">
              <MediaFile
                onChange={this.handleUploadFile}
                title="Agregar acta"
                width={"15rem"}
                height={"2rem"}
                noRow={true}
                meta_data="acta"
              />
            </div>
            <div className="row mt-1">
              {work_order_fine.id &&
                work_order_fine.media &&
                work_order_fine.media.map((val, idx) => {
                  return (
                    <div className="col-12" key={val.id}>
                      <Link
                        href={api.media_download + "/" + val.id}
                        style={{ fontSize: "0.6rem" }}
                      >
                        Descargar {val.name}
                      </Link>
                      <Button
                        onClick={() => {
                          this.handleDeleteMedia(val.id);
                        }}
                      >
                        <CancelIcon
                          style={{ height: "0.8rem", width: "0.8rem" }}
                        />
                      </Button>
                    </div>
                  );
                })}
            </div>

            <div className="row mt-2">
              <Button
                className="mt-1"
                variant="contained"
                color="primary"
                size="small"
                style={{ fontSize: "0.75rem" }}
                onClick={e => {
                  this.handleSubmit(e);
                }}
              >
                {this.state.work_order_fine.id ? "Guardar" : "Cargar"}
              </Button>
              {this.state.work_order_fine.id && (
                <Button
                  className="mt-1 ml-2"
                  variant="contained"
                  color="primary"
                  size="small"
                  style={{ fontSize: "0.75rem" }}
                  onClick={e => {
                    this.handleSendEmail(e);
                  }}
                >
                  Enviar Email
                </Button>
              )}
            </div>
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

export default withStyles(useStyles)(Fine);
